import calc from 'calculatorjs'
import { isMagicbuyProject } from '@g/utils/projectUtils'

function formatSplitFeeText (feeFormulas, fallbackAmount) {
  const srFeesSplit = feeFormulas?.srFeesSplit
  if (!Array.isArray(srFeesSplit) || !srFeesSplit.length) return ''

  const equalIndex = srFeesSplit.indexOf('=')
  const expression = equalIndex > -1
    ? srFeesSplit.slice(0, equalIndex)
    : srFeesSplit
  const amount = equalIndex > -1
    ? srFeesSplit[equalIndex + 1]
    : fallbackAmount

  if (!expression.length || amount === undefined || amount === null || amount === '') return ''
  return `${expression.join(' ')} = ${amount}元`
}

function formatFxFeeText (feeFormulas, couponDiscount, fallbackAmount) {
  const srFees = feeFormulas?.srFees
  if (!Array.isArray(srFees) || srFees.length < 3) {
    return formatSplitFeeText(feeFormulas, fallbackAmount)
  }

  let feeText = `${srFees[0]}KG * ${srFees[2]}元`
  if (couponDiscount < 1) {
    feeText += ` * ${calc.mul(couponDiscount, 100)}折卡`
  }
  feeText += ` = ${Math.ceil(calc(`${srFees[0]}*${srFees[2]}*${couponDiscount}`))}元`
  return feeText
}

const state = {
  showVaorderOrderDialogData: {
    show: false,
    showPay: false,
    vaOid: '',
  },

  serviceItems: [
    {
      text: '快遞面單拍照',
      value: 'sses',
      icon: 'iconkuaidi',
    },
    {
      // text: '開箱驗貨',
      text: '開箱驗貨',
      value: 'ooba',
      icon: 'iconjianchaxiaci',
      hasObbFee: true,
    },
    {
      text: '確認型號',
      value: 'oobno',
      icon: 'iconquerenxinghao',
      hasObbFee: true,
    },
    {
      text: '清點數量',
      value: 'oobct',
      icon: 'iconqingdianshuliang',
      hasObbFee: true,
    },
    {
      text: '內容物拍照',
      value: 'unboxing',
      icon: 'iconunboxing',
      hasObbFee: true,
    },
    {
      text: '填充氣柱袋',
      value: 'stuffing',
      icon: 'iconstuffing',
      hasObbFee: true,
    },
    {
      text: '包裹拆分',
      value: 'splitpri',
      icon: 'icontubiaozhizuomoban2',
      hasObbFee: true,
    },
    {
      text: '移除禁運品',
      value: 'oobrm',
      icon: 'iconyichujinyunpin',
      hasObbFee: true,
    },

    {
      text: '包裝氣泡棉',
      value: 'reinforce',
      icon: 'iconreinforce',
    },
    {
      text: '包裝氣柱袋',
      value: 'wrapAcb',
      icon: 'iconbaozhuangqizhudai',
    },
    {
      text: '打木架',
      value: 'woodenSpt',
      icon: 'iconicon_make_wooden',
    },
    {
      text: '打木箱',
      value: 'woodenBox',
      icon: 'iconicon_make_case',
    },
    {
      text: '原木燻蒸',
      value: 'ippc',
      icon: 'iconyuanmuxunzhengfuwu',
    },
    {
      text: '更換透明袋',
      value: 'tpBag',
      icon: 'icongenghuantoumingdai',
    },
    {
      text: '外箱標識拍照',
      value: 'ctnLbl',
      icon: 'iconwaixiangbiaoshipaizhao',
    },
    {
      text: '拆木架重打胶合板木架',
      value: 'woodenSptCov',
      icon: 'iconwoodenSptCov',
    }
  ]
}

const getters = {
}

const mutations = {
  setShowVaorderOrderDialogData (state, value) {
    state.showVaorderOrderDialogData = {
      show: true,
      showPay: false,
      vaOid: '',
      ...value
    }
  }
}

const actions = {
  index ({ state, dispatch, rootState }, params) {
    params = params.params ? params : { params }
    return rootState.axios.get('/jyo/v1frontend/vaorder/index', params).then(async (res) => {
      res.data.list = await dispatch('formatOrder', res.data.list)
      return res
    })
  },
  view ({ state, dispatch, rootState }, params) {
    return rootState.axios.get('/jyo/v1frontend/vaorder/view', { params }).then(async (res) => {
      res.data.model = (await dispatch('formatOrder', [res.data.model]))[0]
      return res
    })
  },
  // 仅用于核实付款状态：失败不弹全局错误，也不做展示用的格式化。
  viewPayStatus ({ rootState }, params) {
    return rootState.axios.get('/jyo/v1frontend/vaorder/view', { params, noShowError: true })
  },
  formatOrder (_, orders) {
    return orders.map(order => {
      if (order.vaType === 'fx') {
        order.vaTypeName = '補收運費'

        const extraInfo = order.vaExtraInfo
        const diffParcelsFeeFormulas = extraInfo?.diffParcelsFeeFormulas
        if (Array.isArray(diffParcelsFeeFormulas)) {
          const diffParcelsFeeFormulasTexts = diffParcelsFeeFormulas.join('').split('-')
          let couponDiscount = 1
          const newFeeTexts = diffParcelsFeeFormulasTexts[0].split('*')
          if (newFeeTexts.length === 2) {
            couponDiscount = Number(newFeeTexts[1])
          }

          const newFeeText = formatFxFeeText(
            extraInfo.newParcelsFeeFormulas,
            couponDiscount,
            diffParcelsFeeFormulas[0]
          )
          const oldFeeText = formatFxFeeText(
            extraInfo.oldParcelsFeeFormulas,
            couponDiscount,
            diffParcelsFeeFormulas[2]
          )

          if (newFeeText && oldFeeText) {
            extraInfo.fxFormulas = {
              couponDiscount,
              newFeeText,
              oldFeeText,
            }
          }
        }
      } else if (order.vaType === 'oo') {
        order.vaTypeName = '開箱驗貨'
      }
      return order
    })
  },
  batchPay ({ state, commit, rootState }, params) {
    if (isMagicbuyProject(rootState.project) && !params.payMethod) {
      params = { ...params, payMethod: 'creditdg' }
    }
    return rootState.axios.post('/jyo/v1frontend/vaorder/batch-pay', params)
  },
  updateInvoiceInfo ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/vaorder/update-invoice-info', params)
  },
  viewInvoiceInfo ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyo/v1frontend/vaorder/view-invoice-info', { params })
  },
  updateUrgent ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/vaorder/update-urgent', params)
  },
  updateRedo ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/vaorder/update-redo', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
